   let allVideoWrappers =  document.querySelectorAll('.video_wrapper');
    allVideoWrappers.forEach((videoWrapper)=>{
      togglePlayBtn = videoWrapper.querySelector('.play-btn');
      let video =  videoWrapper.querySelector('video');

          togglePlayBtn.addEventListener('click',()=>{
          video.paused ? video.play() : video.pause();
        })
        video.addEventListener('click',()=>{
          video.paused ? video.play() : video.pause();
        })
        video.addEventListener('play',()=>{
        videoWrapper.classList.add('hide-btn')
      })

      video.addEventListener('pause',()=>{
      videoWrapper.classList.remove('hide-btn')
    })
      
      
    })

//footer menu code

let allHeading = document.querySelectorAll('.drop-down h2');

allHeading.forEach((heading) => {
  heading.addEventListener('click', () => {
    const nextElement = heading.nextElementSibling;
    if (nextElement) {
      nextElement.classList.toggle('active');
    }
  });
});

  
const sections = document.querySelectorAll('section.collapsible_tab_section');

if(sections){
  sections.forEach(section => {
    const itemWrapper = section.querySelectorAll('.item_wrapper'); 

    itemWrapper.forEach((item, index) => {
        const title = item.querySelector('.item_heading');
        const content = item.querySelector('.item_content');

        title.addEventListener('click', () => {
            item.classList.toggle('active');

            if (item.classList.contains('active')) {
                content.style.maxHeight = content.scrollHeight + 'px';
            } else {
                content.style.maxHeight = null;
            }

            
            itemWrapper.forEach(otherItem => {
                if (otherItem !== item && otherItem.classList.contains('active')) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.item_content').style.maxHeight = null;
                }
            });
        });

       
        if (index === 0) {
            item.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    });
});
}






     